import { cva, VariantProps } from "class-variance-authority";
import React from "react";

import { cn } from "../../../../../libs/helpers/src";

const dotWrapperVariants = cva(
  "flex size-3.5 items-center justify-center rounded-full",
  {
    variants: {
      intent: {
        lightblue: "bg-lightblue-500 dark:bg-lightblue-500",
        warning: "bg-warning-700 dark:bg-warning-500",
        gray: "bg-gray-500 dark:bg-gray-400",
        error: "bg-error-600 dark:bg-error-500",
        success: "bg-success-600 dark:bg-success-500",
        secondary: "bg-secondary-700 dark:bg-secondary-500",
      },
    },
  },
);

const dotVariants = cva("size-2 rounded-full", {
  variants: {
    intent: {
      lightblue: "bg-lightblue-100 dark:bg-lightblue-900",
      warning: "bg-warning-100 dark:bg-warning-900",
      gray: "bg-gray-100 dark:bg-gray-700",
      error: "bg-error-50 dark:bg-error-900",
      success: "bg-success-50 dark:bg-success-900",
      secondary: "bg-secondary-25 dark:bg-secondary-800",
    },
  },
});

export type DotProps = {
  className?: string;
} & VariantProps<typeof dotVariants>;

export const Dot: React.FC<DotProps> = ({ intent, className }) => {
  return (
    <div className={cn(dotWrapperVariants({ intent }), className)}>
      <div className={cn(dotVariants({ intent }))} />
    </div>
  );
};
